import React, { useState, Fragment, useEffect } from 'react';
import { Row, Input, Label, Button, ModalHeader, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { Colxx } from '../../../../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../../../../components/common/react-notifications';
import { localeOptions } from '../../../../../../../../constants/defaultValues';
import { AxiosAPI } from '../../../../../../../../helpers/AxiosAPI';
import { putAPI_Update_GptPromptTemplate } from '../../../../../../../../constants/APIs';

export default function GptTemplate({ id, visible, toggle, gptTemplate, fetchProperties }) {
    const [inputFields, setInputFields] = useState([]);
    useEffect(() => {
        var result = [];
        localeOptions.map((lang) => {
            result.push({
                title: gptTemplate.filter(l => l.languageCode === lang.id).length > 0 ? gptTemplate.filter(l => l.languageCode === lang.id)[0].title : "",
                languageCode: lang.id
            });
        });
        setInputFields(result);
    }, [gptTemplate]);
    const handleChange = (e, index) => {
        let s = [...inputFields];
        s[index].title = e.target.value;
        setInputFields(s);
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        var templete = inputFields.filter(k => k.title !== "");
        const data = { gptPromptTemplates: [...templete], updater: 'admin' };
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_GptPromptTemplate}/${id}`,
            data,
        }).then(() => {
            toggle();
            if (fetchProperties !== undefined) {
                fetchProperties();
            }
            setTimeout(() => {
                NotificationManager.success(
                    '',
                    'GPT Prompt Template Saved Successfully!!',
                    3000,
                    null,
                    null,
                    'success'
                );
            }, 300)
        });
    }
    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>GPT Prompt Template</ModalHeader>
                <ModalBody>
                    <Row>
                        {inputFields.map((elem, i) => (
                            <Fragment>
                                <Colxx sm={3} className="md-3">
                                    <Label>{localeOptions.filter(l => l.id === elem.languageCode)[0].name}</Label>
                                </Colxx>
                                <Colxx sm={9} className="mb-3">
                                    <Input className='input_sty'
                                        type="text"
                                        value={elem.title}
                                        onChange={(e) => handleChange(e, i)}
                                        name="name"
                                    />
                                </Colxx>
                            </Fragment>
                        ))}
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleSubmit}>
                        Save
                    </Button>
                    <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    )
}